import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { getRefundPassengerLabel } from './refundPassengerUtils';
import { getRequestRefundFamilies, getRequestReason, ReasonCategory } from '../model';
export const useRequestBreadcrumbs = () => {
    const { t } = useTranslation('Refund');
    const reason = useSelector(getRequestReason);
    const families = useSelector(getRequestRefundFamilies);
    return useMemo(() => {
        const breadcrumbs = [];
        families.forEach(family => {
            breadcrumbs.push({
                id: `passenger/${family.id}`,
                label: getRefundPassengerLabel(family),
                icon: 'Info/Passenger'
            });
        });
        breadcrumbs.push({
            id: 'reason',
            label: reason ? t(ReasonCategory.Involuntary) : t(ReasonCategory.Voluntary),
            description: reason ? t(reason) : '',
            icon: 'Services/Refundable'
        });
        return breadcrumbs;
    }, [t, reason, families]);
};
